import { rolesObj } from '../../libs/role'

export const PERMISSIONS = {
  MANUAL_GIFTSHOP_CROWN_TRANSFER: 'manual_giftshop_crown_transfer',
  VIEW_FINSYSTEM_DEBT_TRANSACTION: 'view_finsystem_debt_transaction',
  EDIT_FINSYSTEM_DEBT_TRANSACTION: 'edit_finsystem_debt_transaction',
  EDIT_CLIENT_EMAIL: 'edit_client_email',
  DISABLING_TWO_FA: 'disabling_two_fa',
  VIEW_PAYMENT_TRAFFIC_REPORT: 'view_payment_traffic_report',
} as const

export const GUARD_RULES = {
  LOGGED: 'logged',
  USER: 'user',
  VIEW_USERS: 'view_users',
  CREATE_USERS: 'create_users',
  EDIT_USERS: 'edit_users',
  VIEW_ROLE: 'view_role',
  EDIT_ROLE: 'edit_role',
  EDIT_PERMISSION: 'edit_permission',
  CLIENTS_COUNT: 'clients_count',
  VERIFICATION_COUNT: 'verification_count',
  VIEW_CLIENTS: 'view_clients',
  SEARCH_CLIENTS: 'search_clients',
  DOWNLOADS_CLIENTS: 'downloads_clients',
  VIEW_CLIENT_PROFILE_DETAIL: 'view_client_profile_detail',
  VIEW_CLIENT_PROFILE_ACCOUNTS: 'view_client_profile_accounts',
  VIEW_CLIENT_PROFILE_WALLETS: 'view_client_profile_wallets',
  VIEW_CLIENT_PROFILE_PAYMENT_METHODS: 'view_client_profile_payment_methods',
  VIEW_CLIENT_PROFILE_DOCUMENTS: 'view_client_profile_documents',
  VIEW_CLIENT_PROFILE_ACTIVITY: 'view_client_profile_activity',
  VIEW_CLIENT_PROFILE_BONUS111: 'view_client_profile_bonus111',
  VIEW_CLIENT_PROFILE_BONUS150: 'view_client_profile_bonus150',
  VIEW_CLIENT_PROFILE_HISTORY: 'view_client_profile_history',
  VIEW_CLIENT_PROFILE_MONEY_HISTORY: 'view_client_profile_money_history',
  VIEW_CLIENT_PROFILE_CROWN: 'view_client_profile_crown',
  CHANGE_CLIENT_PROFILE_TOTAL_CROWN: 'change_client_profile_total_crown',
  VIEW_CLIENT_PROFILE_COPYTRADE: 'view_client_profile_copytrade',
  VIEW_CLIENT_PROFILE_ATTACH_HISTORY: 'view_client_profile_attach_history',
  VIEW_CLIENT_PROFILE_DEMO: 'view_client_profile_demo',
  EDIT_CLIENTS_DATA: 'edit_clients_data',
  EDIT_CLIENT_EMAIL: 'edit_client_email',
  BLOCK_CLIENTS: 'block_clients',
  ATTACH_PARTNER_TO_CLIENT: 'attach_partner_to_client',
  DETACH_PARTNER_FROM_CLIENT: 'detach_partner_from_client',
  EDIT_ACCOUNT: 'edit_account',
  VIEW_COMMENT_PROFILE: 'view_comment_profile',
  ADD_COMMENT_PROFILE: 'add_comment_profile',
  EDIT_COMMENT_PROFILE: 'edit_comment_profile',
  DELETE_COMMENT_PROFILE: 'delete_comment_profile',
  VIEW_LIST_OF_PARTNERS: 'view_list_of_partners',
  DOWLAND_LIST_OF_PARTNERS: 'dowland_list_of_partners',
  ATTACH_CLIENT_TO_PARTNER: 'attach_client_to_partner',
  DETACH_CLIENT_TO_PARTNER: 'detach_client_to_partner',
  VIEW_PARTNER_PROFILE: 'view_partner_profile',
  CHANGE_STATUS_OF_PARTNER: 'change_status_of_partner',
  STOP_PARTNER_COMMISSION_CALC: 'stop_partner_commission_calc',
  VIEW_AD_MATERIALS: 'view_ad_materials',
  EDIT_AD_MATERIALS: 'edit_ad_materials',
  CREATE_AD_MATERIALS: 'create_ad_materials',
  VIEW_MONTH_RESULTS_CASHBOOSTER: 'view_month_results_cashbooster',
  APPROVE_MONTH_RESULTS_CASHBOOSTER: 'approve_month_results_cashbooster',
  REJECT_REWARD_CASHBOOSTER: 'reject_reward_cashbooster',
  RESTORE_REWARD_CASHBOOSTER: 'restore_reward_cashbooster',
  BLOCK_PARTNER_CASHBOOSTER: 'block_partner_cashbooster',
  SET_BLOCKING_DATE_CASHBOOSTER: 'set_blocking_date_cashbooster',
  UNBLOCK_PARTNER_CASHBOOSTER: 'unblock_partner_cashbooster',
  VIEW_VERIFICATION_LIST: 'view_verification_list',
  VIEW_VERIFICATION: 'view_verification',
  VIEW_VERIFICATION_BADGES: 'view_verification_badges',
  DOWNLOADS_VERIFICATION_LIST: 'downloads_verification_list',
  APPROVE_VERIFICATION: 'approve_verification',
  REJECT_VERIFICATION: 'reject_verification',
  EDIT_VERIFICATION: 'edit_verification',
  EDIT_EXPIRATION_DATE: 'edit_expiration_date',
  CHANGE_STATUS_VERIFICATION: 'change_status_verification',
  ACCEPT_VERIFICATION: 'accept_verification',
  DELETE_FILE_VERIFICATION: 'delete_file_verification',
  ADD_FILE_VERIFICATION: 'add_file_verification',
  VIEW_UPLOADED_IMAGE_VERIFICATION: 'view_uploaded_image_verification',
  VIEW_CARD_VERIFICATION_LIST: 'view_card_verification_list',
  VIEW_CARD_VERIFICATION_BADGES: 'view_card_verification_badges',
  DOWNLOADS_CARD_VERIFICATION_LIST: 'downloads_card_verification_list',
  VIEW_CARD_VERIFICATION_CARD: 'view_card_verification_card',
  EDIT_CARD_VERIFICATION_CARD: 'edit_card_verification_card',
  VIEW_PAYMENTS: 'view_payments',
  EDIT_PAYMENTS: 'edit_payments',
  EDIT_SORT_PAYMENTS: 'edit_sort_payments',
  UPDATE_PAYMENTS: 'update_payments',
  VIEW_TRANSACTIONS: 'view_transactions',
  VIEW_TRANSACTIONS_BADGES: 'view_transactions_badges',
  VIEW_CARD_OF_TRANSACTION: 'view_card_of_transaction',
  EXPORT_TRANSACTIONS: 'export_transactions',
  EDIT_TRANASACTION_DATA: 'edit_tranasaction_data',
  EDIT_TRANASACTION_STATUS: 'edit_tranasaction_status',
  EDIT_AMOUNT: 'edit_amount',
  CHANGE_MANAGER_OF_TRANSACTION: 'change_manager_of_transaction',
  CHANGE_COMPANY_PURSE: 'change_company_purse',
  EDIT_CLIENT_PURSE: 'edit_client_purse',
  CREATE_BALANCE_OPERATION_IB: 'create_balance_operation_ib',
  VIEW_EXCHANGER_LIST: 'view_exchanger_list',
  VIEW_EXCHANGER_WALLET: 'view_exchanger_wallet',
  CREATE_EXCHANGER_WALLET: 'create_exchanger_wallet',
  EDIT_EXCHANGER_WALLET: 'edit_exchanger_wallet',
  VIEW_LINK_TO_EX_GATEWAY: 'view_link_to_ex_gateway',
  VIEW_FIN_ALL_WALLETS: 'view_fin_all_wallets',
  VIEW_FIN_WALLETS: 'view_fin_wallets',
  CREATE_FIN_TRANSACTION: 'create_fin_transaction',
  EDIT_FINSYSTEM_CLIENT_TRANSACTION: 'edit_finsystem_client_transaction',
  VIEW_FIN_REVISIONS: 'view_fin_revisions',
  VIEW_FIN_ALLOWED_REVISIONS: 'view_fin_allowed_revisions',
  EDIT_FIN_ALL_REVISIONS: 'edit_fin_all_revisions',
  EDIT_FIN_ALLOWED_REVISIONS: 'edit_fin_allowed_revisions',
  VIEW_FIN_STATEMENT: 'view_fin_statement',
  VIEW_BUDGET_ITEMS: 'view_budget_items',
  EDIT_BUDGET_ITEMS: 'edit_budget_items',
  VIEW_SECTION: 'view_section',
  EDIT_SECTION: 'edit_section',
  VIEW_KPI: 'view_kpi',
  VIEW_GIFT_CATEGORIES: 'view_gift_categories',
  EDIT_GIFT_CATEGORY: 'edit_gift_category',
  NAV_GIFTSHOP: 'nav_giftshop',
  VIEW_GIFTS: 'view_gifts',
  CREATE_GIFT: 'create_gift',
  VIEW_LIST_OF_GIFT_ORDERS: 'view_list_of_gift_orders',
  VIEW_GIFT_ORDER: 'view_gift_order',
  VIEW_GIFT_ORDER_BADGES: 'view_gift_order_badges',
  EDIT_GIFT_ORDER: 'edit_gift_order',
  PROCESS_GIFT_ORDER: 'process_gift_order',
  VIEW_LIST_OF_STRATEGIES: 'view_list_of_strategies',
  VIEW_STRATEDY: 'view_stratedy',
  EDIT_STRATEGY: 'edit_strategy',
  VIEW_STRATEGY: 'view_strategy',
  EDIT_AI_ASSESSMENT: 'edit_ai_assessment',
  SYNC_FORBIDDEN_DOMAINS_LIST: 'sync_forbidden_domains_list',
  VIEW_FORBIDDEN_DOMAINS_LIST: 'view_forbidden_domains_list',
  CREATE_FORBIDDEN_DOMAINS: 'create_forbidden_domains',
  VIEW_LIST_OF_DEMOCONTEST: 'view_list_of_democontest',
  VIEW_DEMOCONTEST: 'view_democontest',
  CREATE_DEMOCONTEST: 'create_democontest',
  EDIT_DEMOCONTEST: 'edit_democontest',
  EDIT_STATUS_DEMOCONTEST: 'edit_status_democontest',
  PAY_WINNERS_DEMOCONTEST: 'pay_winners_democontest',
  VIEW_CONTEST: 'view_contest',
  EDIT_CONTEST: 'edit_contest',
  BAN_CLIENTS_OF_CONTEST: 'ban_clients_of_contest',
  VIEW_TRANSLATIONS: 'view_translations',
  EDIT_TRANSLATIONS: 'edit_translations',
  SYNC_TRANSLATIONS: 'sync_translations',
  TECH_PAGE_VIEW: 'tech_page_view',
  NEW_YEAR_2026_VIEW: 'new_year_2026_view',
  NEW_YEAR_2026_BAN: 'new_year_2026_ban',
  NEW_YEAR_2026_TASK_UPDATE: 'new_year_2026_task_update',
  NEW_YEAR_2026_TASK_EDIT: 'new_year_2026_task_edit',
  NEW_YEAR_2026_WINNERS: 'new_year_2026_winners',
  VIEW_RESERVED_TICKETS_NY26: 'view_reserved_tickets_ny26',
  RESERVE_TICKET_NY26: 'reserve_ticket_ny26',
  ISSUE_TICKET_NY26: 'issue_ticket_ny26',
  DISABLING_2FA: 'disabling_2FA',
  VIEW_KPI_FINDEP: 'view_kpi_findep',
  SETTING_KPI_FINDEP: 'setting_kpi_findep',
  VIEW_KPI_FINDEP_OWN: 'view_kpi_findep_own',
  EDIT_GATEWAY: 'edit_gateway',
  VIEW_BUDGET_DEPARTMENT: 'view_budget_department',
  CREATE_MANUAL_DEPOSIT_NOVA: 'create_manual_deposit_nova',
  VIEW_KPI_INCOME: 'view_kpi_income',
  CREATE_HELP2PAY_ADJUSTMENT_DEPOSIT: 'create_help2pay_adjustment_deposit',
  GOLDEN_MAY_2026_VIEW: 'golden_may_2026_view',
  GOLDEN_MAY_2026_BAN: 'golden_may_2026_ban',
  GOLDEN_MAY_2026_TASK_UPDATE: 'golden_may_2026_task_update',
  GOLDEN_MAY_2026_TASK_EDIT: 'golden_may_2026_task_edit',
  GOLDEN_MAY_2026_WINNERS: 'golden_may_2026_winners',
  VIEW_RESERVED_TICKETS_GM26: 'view_reserved_tickets_gm26',
  RESERVE_TICKET_GM26: 'reserve_ticket_gm26',
  ISSUE_TICKET_GM26: 'issue_ticket_gm26',
  VIEW_FIN_ALLOWED_WALLETS: 'view_fin_allowed_wallets',
  WORLD_CUP_2026_VIEW: 'world_cup_2026_view',
  WORLD_CUP_2026_BAN: 'world_cup_2026_ban',
  WORLD_CUP_2026_TASK_UPDATE: 'world_cup_2026_task_update',
  WORLD_CUP_2026_TASK_EDIT: 'world_cup_2026_task_edit',
  WORLD_CUP_2026_WINNERS: 'world_cup_2026_winners',
  WORLD_CUP_TICKETS_GM26: 'world_cup_tickets_gm26',
  PARTNER_CONTEST_2026_VIEW: 'view_partner_contest_2026',
  PARTNER_CONTEST_2026_EXPORT: 'export_winner_partner_contest_2026',
  PARTNER_CONTEST_2026_STATUS: 'change_participants_status',
  PARTNER_CONTEST_2026_STAGE: 'change_contest_stage',
  PARTNER_CONTEST_2026_POINTS: 'change_participants_total_points',
  VIEW_RESERVED_TICKETS_WC26: 'view_reserved_tickets_wc26',
  RESERVE_TICKET_WC26: 'reserve_ticket_wc26',
  ISSUE_TICKET_WC26: 'issue_ticket_wc26',
  EDIT_PAYMENT_GATEWAY_NOTIFICATION: 'edit_payment_gateway_notification',
  CREATE_PAYMENTS: 'create_payments',
  VIEW_PAYMENTS_WD_GROUP: 'view_payments_wd_group',
  EDIT_PAYMENTS_WD_GROUP: 'edit_payments_wd_group',
  VIEW_BALANCE_OPERATION: 'view_balance_operation',
  CREATE_BALANCE_OPERATION: 'create_balance_operation',
  VIEW_NOVA_ORDERS: 'view_nova_orders',
  VIEW_NOVA_DIVIDENDS: 'view_nova_dividends',
  VIEW_NOVA_DIVIDEND_EVENT: 'view_nova_dividend_event',
  EDIT_NOVA_DIVIDEND_EVENT: 'edit_nova_dividend_event',
  VIEW_NOVA_OWNER_WALLETS: 'view_nova_owner_wallets',
  VIEW_NOVA_SELL_OFFERS: 'view_nova_sell_offers',
  VIEW_NOVA_SELL_PAYOUTS: 'view_nova_sell_payouts',
  VIEW_NOVA_HOT_BUY_ORDERS: 'view_nova_hot_buy_orders',
  VIEW_NOVA_INSTALMENTS: 'view_nova_instalments',
  VIEW_NOVA_LIST_OF_PROPERTIES: 'view_nova_list_of_properties',
  VIEW_NOVA_CARD_OF_PROPERTIES: 'view_nova_card_of_properties',
  CREATE_BUDGET_ITEMS: 'create_budget_items',
  VIEW_BUDGET_SECTIONS: 'view_budget_sections',
  CREATE_BUDGET_SECTIONS: 'create_budget_sections',
  EDIT_BUDGET_SECTIONS: 'edit_budget_sections',
  VIEW_LIST_OF_PROMOCODES: 'view_list_of_promocodes',
  CREATE_PROMOCODE: 'create_promocode',
  EDIT_PROMOCODE: 'edit_promocode',
  VIEW_PROMOCODES_USAGE: 'view_promocodes_usage',
  VIEW_PROMOCODES_SETTINGS: 'view_promocodes_settings',
  VIEW_LIST_OF_TRANSLATIONS: 'view_list_of_translations',
  VIEW_LIST_OF_PROMO: 'view_list_of_promo',
  VIEW_VERIFICATION_WORK_REPORT: 'view_verification_work_report',
  CREATE_BUDGET_ARTICLE: 'create_budget_article',
  MANAGE_BUDGET_ARTICLE_ACCESS: 'manage_budget_article_access',
  DELETE_BUDGET_ARTICLE: 'delete_budget_article',
  VIEW_CRYPTO_WALLETS: 'view_crypto_wallets',
  MANAGE_WALLET_ALERTS: 'manage_wallet_alerts',
  CHECK_CRYPTO_WALLET: 'check_crypto_wallet',
  CHECK_CRYPTO_TRANSACTION: 'check_crypto_transaction',
  EDIT_CRYPTO_WALLET: 'edit_crypto_wallet',
  VIEW_CRYPTO_WALLET: 'view_crypto_wallet',
} as const

export const getRolesByGuardRules = (rule: string) => {
  switch (rule) {
    case GUARD_RULES.LOGGED:
      return [rolesObj.logged]
    case GUARD_RULES.USER:
      return [rolesObj.user]
    // Users
    case GUARD_RULES.VIEW_USERS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cfo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.admin,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.CREATE_USERS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cfo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.admin,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.EDIT_USERS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cfo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.admin,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.VIEW_ROLE:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cfo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.admin,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.EDIT_ROLE:
      return [rolesObj.ceo, rolesObj.admin, rolesObj.crmDeveloper]
    case GUARD_RULES.EDIT_PERMISSION:
      return [rolesObj.ceo, rolesObj.admin, rolesObj.crmDeveloper]
    // Clients
    case GUARD_RULES.CLIENTS_COUNT:
      return [rolesObj.ceo, rolesObj.cfo, rolesObj.cto, rolesObj.cmo]
    case GUARD_RULES.VERIFICATION_COUNT:
      return [rolesObj.ceo, rolesObj.cfo, rolesObj.cto, rolesObj.cmo]
    case GUARD_RULES.VIEW_CLIENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.SEARCH_CLIENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.DOWNLOADS_CLIENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_DETAIL:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_ACCOUNTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_WALLETS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_PAYMENT_METHODS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_DOCUMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_ACTIVITY:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_HISTORY:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.po,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_BONUS111:
    case GUARD_RULES.VIEW_CLIENT_PROFILE_BONUS150:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_MONEY_HISTORY:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_CROWN:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.CHANGE_CLIENT_PROFILE_TOTAL_CROWN:
      return [rolesObj.ceo, rolesObj.headOfSupport, rolesObj.giftshopPO]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_COPYTRADE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_ATTACH_HISTORY:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_CLIENT_PROFILE_DEMO:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_CLIENTS_DATA:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
      ]
    case GUARD_RULES.EDIT_CLIENT_EMAIL:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
      ]
    case GUARD_RULES.BLOCK_CLIENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.supportManager,
        rolesObj.verificationAgent,
      ]
    case GUARD_RULES.ATTACH_PARTNER_TO_CLIENT:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.DETACH_PARTNER_FROM_CLIENT:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_ACCOUNT:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.VIEW_COMMENT_PROFILE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.verificator,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.ADD_COMMENT_PROFILE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.verificator,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.EDIT_COMMENT_PROFILE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
      ]
    case GUARD_RULES.DELETE_COMMENT_PROFILE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.seniorVerificator,
      ]
    // IB
    case GUARD_RULES.VIEW_LIST_OF_PARTNERS:
      return [
        rolesObj.cfo,
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.tester,
        rolesObj.bsa,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.DOWLAND_LIST_OF_PARTNERS:
      return [rolesObj.ceo, rolesObj.headOfPartnerships]
    case GUARD_RULES.ATTACH_CLIENT_TO_PARTNER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.DETACH_CLIENT_TO_PARTNER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_PARTNER_PROFILE:
      return [
        rolesObj.cfo,
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.tester,
        rolesObj.bsa,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.CHANGE_STATUS_OF_PARTNER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.STOP_PARTNER_COMMISSION_CALC:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_AD_MATERIALS:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.tester,
        rolesObj.bsa,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_AD_MATERIALS:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.CREATE_AD_MATERIALS:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_MONTH_RESULTS_CASHBOOSTER:
      return [
        rolesObj.cfo,
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.tester,
        rolesObj.bsa,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.dealer,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.APPROVE_MONTH_RESULTS_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.REJECT_REWARD_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.RESTORE_REWARD_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.BLOCK_PARTNER_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.SET_BLOCKING_DATE_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.UNBLOCK_PARTNER_CASHBOOSTER:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    // Verification
    case GUARD_RULES.VIEW_VERIFICATION:
      return [rolesObj.verificator, rolesObj.seniorVerificator]
    case GUARD_RULES.VIEW_VERIFICATION_LIST:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.VIEW_VERIFICATION_BADGES:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
      ]
    case GUARD_RULES.DOWNLOADS_VERIFICATION_LIST:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.APPROVE_VERIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.ACCEPT_VERIFICATION:
      return [rolesObj.verificator, rolesObj.seniorVerificator]
    case GUARD_RULES.REJECT_VERIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.leadFinanceManager,
        rolesObj.verificator,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.EDIT_VERIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.leadFinanceManager,
        rolesObj.verificator,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.DELETE_FILE_VERIFICATION:
      return [rolesObj.seniorVerificator]
    case GUARD_RULES.ADD_FILE_VERIFICATION:
      return [rolesObj.seniorVerificator]
    case GUARD_RULES.EDIT_EXPIRATION_DATE:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.leadFinanceManager,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.CHANGE_STATUS_VERIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.verificationAgent,
        rolesObj.leadFinanceManager,
        rolesObj.seniorVerificator,
      ]
    case GUARD_RULES.VIEW_UPLOADED_IMAGE_VERIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.verificationAgent,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    // Card verification
    case GUARD_RULES.VIEW_CARD_VERIFICATION_LIST:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.VIEW_CARD_VERIFICATION_BADGES:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.DOWNLOADS_CARD_VERIFICATION_LIST:
      return [
        rolesObj.ceo,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.VIEW_CARD_VERIFICATION_CARD:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.EDIT_CARD_VERIFICATION_CARD:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.crmDeveloper,
      ]
    // Finances
    case GUARD_RULES.VIEW_PAYMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.gateway,
      ]
    case GUARD_RULES.EDIT_PAYMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.billingManager,
        rolesObj.gateway,
      ]
    case GUARD_RULES.EDIT_SORT_PAYMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.billingManager,
        rolesObj.gateway,
      ]
    case GUARD_RULES.UPDATE_PAYMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.billingManager,
        rolesObj.gateway,
      ]
    case GUARD_RULES.VIEW_TRANSACTIONS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.po,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.VIEW_TRANSACTIONS_BADGES:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.VIEW_CARD_OF_TRANSACTION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.EXPORT_TRANSACTIONS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.EDIT_TRANASACTION_DATA:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.EDIT_TRANASACTION_STATUS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.EDIT_GATEWAY:
      return [rolesObj.gateway, rolesObj.crmDeveloper]
    case GUARD_RULES.EDIT_AMOUNT:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.CHANGE_MANAGER_OF_TRANSACTION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.CHANGE_COMPANY_PURSE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.EDIT_CLIENT_PURSE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.CREATE_BALANCE_OPERATION_IB:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.headOfPartnerships,
      ]
    // Exchanger
    case GUARD_RULES.VIEW_EXCHANGER_LIST:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_EXCHANGER_WALLET:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.bsa,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.CREATE_EXCHANGER_WALLET:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_EXCHANGER_WALLET:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_LINK_TO_EX_GATEWAY:
      return [
        rolesObj.ceo,
        rolesObj.headOfPartnerships,
        rolesObj.billingManager,
        rolesObj.seniorPartnerManager,
      ]
    // Finance System
    case GUARD_RULES.VIEW_FIN_ALL_WALLETS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.VIEW_FIN_WALLETS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.CREATE_FIN_TRANSACTION:
    case GUARD_RULES.EDIT_FINSYSTEM_CLIENT_TRANSACTION:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.VIEW_FIN_REVISIONS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.finSystemPO,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.VIEW_FIN_ALLOWED_REVISIONS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.EDIT_FIN_ALL_REVISIONS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.EDIT_FIN_ALLOWED_REVISIONS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
      ]
    case GUARD_RULES.VIEW_FIN_STATEMENT:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.VIEW_VERIFICATION_WORK_REPORT:
      return [rolesObj.headOfSupport, rolesObj.crmDeveloper]
    case GUARD_RULES.VIEW_BUDGET_ITEMS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.EDIT_BUDGET_ITEMS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.VIEW_SECTION:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    case GUARD_RULES.EDIT_SECTION:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]
    // KPI
    case GUARD_RULES.VIEW_KPI:
      return [rolesObj.ceo, rolesObj.cmo]
    // Giftshop
    case GUARD_RULES.VIEW_GIFT_CATEGORIES:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.giftshopPO,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.EDIT_GIFT_CATEGORY:
      return [rolesObj.ceo, rolesObj.giftshopPO]
    case GUARD_RULES.VIEW_GIFTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.giftshopPO,
        rolesObj.giftshopManager,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.CREATE_GIFT:
      return [rolesObj.ceo, rolesObj.giftshopPO]
    case GUARD_RULES.VIEW_LIST_OF_GIFT_ORDERS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.giftshopPO,
        rolesObj.giftshopManager,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.NAV_GIFTSHOP:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.giftshopPO,
        rolesObj.giftshopManager,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_GIFT_ORDER:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.giftshopPO,
        rolesObj.giftshopManager,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_GIFT_ORDER_BADGES:
      return [rolesObj.ceo, rolesObj.giftshopPO, rolesObj.crmDeveloper]
    case GUARD_RULES.EDIT_GIFT_ORDER:
      return [rolesObj.ceo, rolesObj.giftshopPO]
    case GUARD_RULES.PROCESS_GIFT_ORDER:
      return [rolesObj.ceo, rolesObj.giftshopPO, rolesObj.giftshopManager]
    // Copytrade
    case GUARD_RULES.VIEW_LIST_OF_STRATEGIES:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.copytradePO,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_STRATEDY:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.copytradePO,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_STRATEGY:
      return [rolesObj.ceo, rolesObj.copytradePO, rolesObj.headOfSupport]
    case GUARD_RULES.VIEW_STRATEGY:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.copytradePO,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
      ]
    case GUARD_RULES.EDIT_AI_ASSESSMENT:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.copytradePO, rolesObj.dealer]
    // Forbidden domain
    case GUARD_RULES.SYNC_FORBIDDEN_DOMAINS_LIST:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.crmDeveloper,
        rolesObj.po,
      ]
    case GUARD_RULES.VIEW_FORBIDDEN_DOMAINS_LIST:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.headOfPartnerships,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.crmDeveloper,
        rolesObj.admin,
      ]
    case GUARD_RULES.CREATE_FORBIDDEN_DOMAINS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.admin,
        rolesObj.po,
      ]
    // Demo Contest
    case GUARD_RULES.VIEW_LIST_OF_DEMOCONTEST:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.promoPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_DEMOCONTEST:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.promoPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.contestManager,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.CREATE_DEMOCONTEST:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.promoPO,
        rolesObj.contestManager,
      ]
    case GUARD_RULES.EDIT_DEMOCONTEST:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.promoPO,
        rolesObj.contestManager,
      ]
    case GUARD_RULES.EDIT_STATUS_DEMOCONTEST:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.promoPO]
    case GUARD_RULES.PAY_WINNERS_DEMOCONTEST:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.promoPO]
    // Promo Contest
    case GUARD_RULES.VIEW_CONTEST:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.promoPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.EDIT_CONTEST:
      return [rolesObj.promoPO, rolesObj.ceo, rolesObj.headOfSupport]
    case GUARD_RULES.BAN_CLIENTS_OF_CONTEST:
      return [rolesObj.promoPO, rolesObj.ceo, rolesObj.headOfSupport]
    // Translations
    case GUARD_RULES.VIEW_TRANSLATIONS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.contestManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.po,
      ]
    case GUARD_RULES.EDIT_TRANSLATIONS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.contestManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.po,
      ]
    case GUARD_RULES.SYNC_TRANSLATIONS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.contestManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.TECH_PAGE_VIEW:
      return [rolesObj.crmDeveloper, rolesObj.root]
    case GUARD_RULES.NEW_YEAR_2026_VIEW:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.productOwner,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.dealer,
        rolesObj.tester,
        rolesObj.bca,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.NEW_YEAR_2026_BAN:
      return [rolesObj.ceo, rolesObj.productOwner, rolesObj.headOfSupport]
    case GUARD_RULES.NEW_YEAR_2026_TASK_UPDATE:
      return [
        rolesObj.ceo,
        rolesObj.productOwner,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.NEW_YEAR_2026_TASK_EDIT:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.NEW_YEAR_2026_WINNERS:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.VIEW_RESERVED_TICKETS_NY26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.RESERVE_TICKET_NY26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.ISSUE_TICKET_NY26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.DISABLING_2FA:
      return [rolesObj.ceo, rolesObj.headOfSupport]
    case GUARD_RULES.VIEW_KPI_FINDEP:
    case GUARD_RULES.SETTING_KPI_FINDEP:
      return [rolesObj.ceo, rolesObj.cfo]
    case GUARD_RULES.VIEW_KPI_FINDEP_OWN:
      return [
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
      ]
    case GUARD_RULES.VIEW_BUDGET_DEPARTMENT:
      return [rolesObj.budget]
    case GUARD_RULES.CREATE_MANUAL_DEPOSIT_NOVA:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
      ]
    case GUARD_RULES.VIEW_KPI_INCOME:
      return [rolesObj.ceo, rolesObj.crmDeveloper]
    case GUARD_RULES.CREATE_HELP2PAY_ADJUSTMENT_DEPOSIT:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.GOLDEN_MAY_2026_VIEW:
    case GUARD_RULES.WORLD_CUP_2026_VIEW:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.productOwner,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.leadFinanceManager,
        rolesObj.dealer,
        rolesObj.tester,
        rolesObj.bca,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.PARTNER_CONTEST_2026_VIEW:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.GOLDEN_MAY_2026_BAN:
    case GUARD_RULES.WORLD_CUP_2026_BAN:
      return [rolesObj.ceo, rolesObj.productOwner, rolesObj.headOfSupport]
    case GUARD_RULES.PARTNER_CONTEST_2026_STATUS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.PARTNER_CONTEST_2026_STAGE:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.headOfPartnerships,
      ]
    case GUARD_RULES.PARTNER_CONTEST_2026_POINTS:
      return ['ROLE_CHANGE_PARTNER_POINT']
    case GUARD_RULES.PARTNER_CONTEST_2026_EXPORT:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.headOfPartnerships,
        rolesObj.seniorPartnerManager,
      ]
    case GUARD_RULES.GOLDEN_MAY_2026_TASK_UPDATE:
    case GUARD_RULES.WORLD_CUP_2026_TASK_UPDATE:
      return [
        rolesObj.ceo,
        rolesObj.productOwner,
        rolesObj.headOfSupport,
        rolesObj.supportManager,
        rolesObj.supportAgent,
      ]
    case GUARD_RULES.GOLDEN_MAY_2026_TASK_EDIT:
    case GUARD_RULES.WORLD_CUP_2026_TASK_EDIT:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.GOLDEN_MAY_2026_WINNERS:
    case GUARD_RULES.WORLD_CUP_2026_WINNERS:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.VIEW_RESERVED_TICKETS_GM26:
    case GUARD_RULES.VIEW_RESERVED_TICKETS_WC26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.RESERVE_TICKET_GM26:
    case GUARD_RULES.RESERVE_TICKET_WC26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.ISSUE_TICKET_GM26:
    case GUARD_RULES.ISSUE_TICKET_WC26:
      return [rolesObj.ceo, rolesObj.productOwner]
    case GUARD_RULES.VIEW_FIN_ALLOWED_WALLETS:
      return [
        rolesObj.ceo,
        rolesObj.cmo,
        rolesObj.cfo,
        rolesObj.fpo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.financeManager,
      ]
    case GUARD_RULES.WORLD_CUP_TICKETS_GM26:
      return [rolesObj.ceo, rolesObj.productOwner]

    case GUARD_RULES.CREATE_PAYMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.billingManager,
      ]

    case GUARD_RULES.VIEW_PAYMENTS_WD_GROUP:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
      ]

    case GUARD_RULES.EDIT_PAYMENTS_WD_GROUP:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.billingManager,
      ]

    case GUARD_RULES.VIEW_BALANCE_OPERATION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.CREATE_BALANCE_OPERATION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.financeManager,
      ]

    case GUARD_RULES.EDIT_PAYMENT_GATEWAY_NOTIFICATION:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.financeManager,
        rolesObj.billingManager,
      ]

    case GUARD_RULES.VIEW_NOVA_ORDERS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_DIVIDENDS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_DIVIDEND_EVENT:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.EDIT_NOVA_DIVIDEND_EVENT:
      return [rolesObj.ceo, rolesObj.cfo, rolesObj.novaPO]

    case GUARD_RULES.VIEW_NOVA_OWNER_WALLETS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_SELL_OFFERS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_SELL_PAYOUTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_HOT_BUY_ORDERS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_INSTALMENTS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_LIST_OF_PROPERTIES:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_NOVA_CARD_OF_PROPERTIES:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.novaPO,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.financeManager,
        rolesObj.leadFinanceManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.CREATE_BUDGET_ITEMS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]

    case GUARD_RULES.VIEW_BUDGET_SECTIONS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]

    case GUARD_RULES.CREATE_BUDGET_SECTIONS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]

    case GUARD_RULES.EDIT_BUDGET_SECTIONS:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.cfo, rolesObj.fpo]

    case GUARD_RULES.VIEW_LIST_OF_PROMOCODES:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.financeManager,
        rolesObj.seniorFinanceManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.CREATE_PROMOCODE:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.po]

    case GUARD_RULES.EDIT_PROMOCODE:
      return [rolesObj.ceo, rolesObj.cmo, rolesObj.po]

    case GUARD_RULES.VIEW_PROMOCODES_USAGE:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]

    case GUARD_RULES.VIEW_PROMOCODES_SETTINGS:
      return [
        rolesObj.ceo,
        rolesObj.cfo,
        rolesObj.cto,
        rolesObj.cmo,
        rolesObj.po,
        rolesObj.billingManager,
        rolesObj.headOfSupport,
        rolesObj.headOfPartnerships,
        rolesObj.supportManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.dealer,
        rolesObj.crmDeveloper,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
      ]
    case GUARD_RULES.VIEW_LIST_OF_TRANSLATIONS:
      return [
        rolesObj.ceo,
        rolesObj.cto,
        rolesObj.contestManager,
        rolesObj.bsa,
        rolesObj.tester,
        rolesObj.crmDeveloper,
        rolesObj.po,
      ]
    case GUARD_RULES.VIEW_LIST_OF_PROMO:
      return [
        rolesObj.dealer,
        rolesObj.supportManager,
        rolesObj.supportAgent,
        rolesObj.seniorPartnerManager,
        rolesObj.juniorPartnerManager,
        rolesObj.po,
        rolesObj.promoPO,
        rolesObj.crmDeveloper,
      ]
    case GUARD_RULES.CREATE_BUDGET_ARTICLE:
      return [rolesObj.ceo, rolesObj.admin, rolesObj.budget]
    case GUARD_RULES.DELETE_BUDGET_ARTICLE:
      return [rolesObj.ceo, rolesObj.admin]
    default:
      return []
  }
}
